/* =========================================================
   QUICKSTRINGS DELIVERY FLOW

   String Type
        ↓
   Pickup Date
        ↓
   Pickup Slot
        ↓
   Delivery Date
        ↓
   Delivery Slot

   RULES
   ---------------------------------------------------------
   Pickup 10 AM - 12 PM
   → Same day: 2 PM - 5 PM / 5 PM - 8 PM

   Pickup 12 PM - 2 PM
   → Same day: 5 PM - 8 PM

   Pickup 2 PM - 5 PM
   → Same day unavailable

   Pickup 5 PM - 8 PM
   → Same day unavailable

   Next day
   → All 4 delivery slots

   2+ days
   → All 4 delivery slots

   PRICING
   Same day  = ₹100
   Next day  = ₹50
   2+ days   = ₹0
   ========================================================= */

(function () {

  'use strict';

/* =========================================================
   MANUALLY DISABLED DATES
   ---------------------------------------------------------
   Add dates here whenever a date should not be selectable.

   Format: YYYY-MM-DD

   Example:
   '2026-08-25'
   ========================================================= */

const DISABLED_PICKUP_DATES = [
  '2026-09-20',
  '2026-09-22'
];

const DISABLED_DELIVERY_DATES = [
  '2026-09-21',
  '2026-09-23'
];

  /* =========================================================
     SELECTORS
     ========================================================= */

  const PICKUP =
    '[data-element-id="dropdown-4"]';

  const SLOT =
    '[data-element-id="dropdown-1"]';

  const CUSTOM_PICKER =
    '#qs-custom-delivery-picker';


  const PICKUP_DATE_SELECTORS = [
    '#qs-pickup-date',
    '#pickup-date',
    '#pickup_date',
    'input[name="pickup-date"]',
    'input[name="pickup_date"]',
    'input[data-pickup-date]'
  ];


  const DELIVERY_DATE_SELECTORS = [
    '#qs-delivery-date',
    '#delivery-date',
    '#delivery_date',
    'input[name="delivery-date"]',
    'input[name="delivery_date"]',
    'input[data-delivery-date]'
  ];


  const DELIVERY_SLOT_SELECTORS = [
    '#qs-delivery-slot',
    '#delivery-slot',
    '#delivery_slot',
    'select[name="properties[Delivery Time Slot]"]',
    'select[data-delivery-slot]'
  ];


  const DELIVERY_SLOT_WRAPPER =
    '#qs-delivery-slot-wrapper';


  const DELIVERY_DATE_WRAPPER =
    '#qs-delivery-date-wrapper';


  let updateTimer = null;


  /* =========================================================
     CSS
     ========================================================= */

  const style =
    document.createElement('style');


  style.textContent = `

    /* Prevent flashing */
    body:not(.delivery-flow-ready) ${PICKUP},
    body:not(.delivery-flow-ready) ${SLOT} {
      visibility: hidden !important;
    }

/* =====================================================
   UNSTRUNG PRODUCT
   ===================================================== */

body.delivery-unstrung-product ${CUSTOM_PICKER},
body.delivery-unstrung-product ${PICKUP},
body.delivery-unstrung-product ${SLOT},
body.delivery-unstrung-product .custom-pickup-date-wrapper,
body.delivery-unstrung-product .qs-delivery-method-control,
body.delivery-unstrung-product #qs-delivery-pricing-display {
  display: none !important;
  visibility: hidden !important;
}

    /* =====================================================
       PRODUCT ONLY
       ===================================================== */

    body.delivery-product-only ${PICKUP},
    body.delivery-product-only ${SLOT},
    body.delivery-product-only ${CUSTOM_PICKER},
    body.delivery-product-only .custom-pickup-date-wrapper,
    body.delivery-product-only .qs-delivery-method-control {
      display: none !important;
      visibility: hidden !important;
    }


    /* =====================================================
       WITH STRING
       ===================================================== */

    body.delivery-with-string
      .custom-pickup-date-wrapper {
      display: block !important;
      visibility: visible !important;
    }


    body.delivery-with-string
      ${PICKUP} {
      display: none !important;
      visibility: hidden !important;
    }


    /* =====================================================
       PICKUP SLOT
       ===================================================== */

    body.delivery-with-string:not(.pickup-date-selected)
      ${SLOT} {
      display: none !important;
      visibility: hidden !important;
    }


    body.delivery-with-string.pickup-date-selected
      ${SLOT},
    body.delivery-with-string.pickup-slot-visible
      ${SLOT} {
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
    }


    /* =====================================================
       DELIVERY DATE
       ===================================================== */

    body.delivery-with-string:not(.pickup-date-selected)
      ${DELIVERY_DATE_WRAPPER} {
      display: none !important;
      visibility: hidden !important;
    }


    body.delivery-with-string.pickup-date-selected
      ${DELIVERY_DATE_WRAPPER} {
      display: block !important;
      visibility: visible !important;
    }


    /* =====================================================
       DELIVERY SLOT
       ===================================================== */

    body.delivery-with-string:not(.delivery-date-selected)
      ${DELIVERY_SLOT_WRAPPER} {
      display: none !important;
      visibility: hidden !important;
    }


    body.delivery-with-string.delivery-date-selected
      ${DELIVERY_SLOT_WRAPPER} {
      display: block !important;
      visibility: visible !important;
    }


    /* =====================================================
       HIDE MANUAL DELIVERY TYPE / PRICE FOR PRODUCT ONLY
       ===================================================== */

    body.delivery-product-only
      .qs-delivery-method-control {
      display: none !important;
      visibility: hidden !important;
    }

  `;


  document.head.appendChild(style);


  /* =========================================================
     STRING TYPE GROUP
     ========================================================= */

  function getStringTypeGroup() {

    const labels =
      document.querySelectorAll('label');


    for (const label of labels) {

      const text =
        label.innerText
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();


      if (text.startsWith('string type')) {

        return label.closest(
          '[data-element-id], .gpo-element, .gpo-form__group, .gpo-col-6, .gpo-col-12'
        ) || label.parentElement;
      }
    }


    return null;
  }


  /* =========================================================
     CHECK PRODUCT ONLY
     ========================================================= */

  function isProductOnly() {

    const group =
      getStringTypeGroup();


    if (!group) {
      return false;
    }


    /* Radio */

    const checkedRadio =
      group.querySelector(
        'input[type="radio"]:checked'
      );


    if (checkedRadio) {

      const value =
        (
          checkedRadio.value || ''
        )
          .trim()
          .toLowerCase();


      const labelText =
        (
          checkedRadio.closest('label')
            ?.innerText || ''
        )
          .trim()
          .toLowerCase();


      if (
        value.includes('product only') ||
        labelText.includes('product only')
      ) {

        return true;
      }
    }


    /* Select */

    const select =
      group.querySelector('select');


    if (select) {

      const option =
        select.options[
          select.selectedIndex
        ];


      const value =
        (
          select.value || ''
        )
          .trim()
          .toLowerCase();


      const text =
        (
          option?.text || ''
        )
          .trim()
          .toLowerCase();


      if (
        value.includes('product only') ||
        text.includes('product only')
      ) {

        return true;
      }
    }


    /* Active fallback */

    const active =
      group.querySelector(
        '.selected, .active, [aria-selected="true"]'
      );


    if (
      active &&
      active.innerText
        .toLowerCase()
        .includes('product only')
    ) {

      return true;
    }


    return false;
  }

/* =========================================================
   PIN CODE VALIDATION
   ---------------------------------------------------------
   WITH STRING
   → Only 6 specific PIN codes

   PRODUCT ONLY
   → 112 Bangalore PIN codes

   NORMAL PRODUCTS
   → 112 Bangalore PIN codes
   ========================================================= */


/* =========================================================
   WITH STRING PIN CODES
   ========================================================= */

const WITH_STRING_PINCODES = [
  '560093',
  '560038',
  '560075',
  '560017',
  '560037',
  '560008'
];


/* =========================================================
   PRODUCT ONLY + NORMAL PRODUCT PIN CODES
   ========================================================= */

const BANGALORE_PINCODES = [
  '560001',
  '560002',
  '560003',
  '560004',
  '560005',
  '560006',
  '560007',
  '560008',
  '560009',
  '560010',
  '560011',
  '560012',
  '560013',
  '560014',
  '560015',
  '560016',
  '560017',
  '560018',
  '560020',
  '560021',
  '560022',
  '560023',
  '560024',
  '560025',
  '560026',
  '560027',
  '560029',
  '560030',
  '560032',
  '560033',
  '560034',
  '560035',
  '560036',
  '560037',
  '560038',
  '560040',
  '560041',
  '560042',
  '560043',
  '560045',
  '560047',
  '560048',
  '560050',
  '560051',
  '560053',
  '560054',
  '560055',
  '560056',
  '560057',
  '560058',
  '560059',
  '560060',
  '560061',
  '560062',
  '560063',
  '560064',
  '560065',
  '560066',
  '560068',
  '560070',
  '560071',
  '560072',
  '560073',
  '560074',
  '560075',
  '560076',
  '560077',
  '560078',
  '560079',
  '560080',
  '560081',
  '560082',
  '560083',
  '560084',
  '560085',
  '560086',
  '560088',
  '560089',
  '560090',
  '560091',
  '560092',
  '560093',
  '560094',
  '560095',
  '560096',
  '560097',
  '560098',
  '560099',
  '560100',
  '560102',
  '560103',
  '560104',
  '560105',
  '560107',
  '560108',
  '560109',
  '560110',
  '560111',
  '560112',
  '560113',
  '560114',
  '560115',
  '560116',
  '560119',
  '560300',
  '562106',
  '562107',
  '562125',
  '562130',
  '562149',
  '562157',
  '562162'
];


/* =========================================================
   GET PIN CODE INPUT
   ========================================================= */

function getPincodeInput() {

  return document.querySelector(
    '#qs-pincode-input'
  );

}


/* =========================================================
   GET PIN CODE MESSAGE
   ========================================================= */

function getPincodeMessage() {

  return document.querySelector(
    '#qs-pincode-message'
  );

}


/* =========================================================
   CHECK WITH STRING
   ========================================================= */

function isWithString() {

  const group =
    getStringTypeGroup();


  /*
   * No String Type group
   * → Normal product
   */

  if (!group) {

    return false;

  }


  /* =====================================================
     RADIO
     ===================================================== */

  const checkedRadio =
    group.querySelector(
      'input[type="radio"]:checked'
    );


  if (checkedRadio) {

    const value =
      (
        checkedRadio.value || ''
      )
        .trim()
        .toLowerCase();


    const label =
      (
        checkedRadio.closest('label')
          ?.innerText || ''
      )
        .trim()
        .toLowerCase();


    if (
      value.includes('with string') ||
      label.includes('with string')
    ) {

      return true;

    }

  }


  /* =====================================================
     SELECT
     ===================================================== */

  const select =
    group.querySelector('select');


  if (select) {

    const option =
      select.options[
        select.selectedIndex
      ];


    const value =
      (
        select.value || ''
      )
        .trim()
        .toLowerCase();


    const text =
      (
        option?.text || ''
      )
        .trim()
        .toLowerCase();


    if (
      value.includes('with string') ||
      text.includes('with string')
    ) {

      return true;

    }

  }


  /* =====================================================
     ACTIVE FALLBACK
     ===================================================== */

  const active =
    group.querySelector(
      '.selected, .active, [aria-selected="true"]'
    );


  if (
    active &&
    (
      active.innerText || ''
    )
      .toLowerCase()
      .includes('with string')
  ) {

    return true;

  }


  return false;

}


/* =========================================================
   GET CURRENT ALLOWED PIN LIST
   ========================================================= */

function getAllowedPincodes() {

  /*
   * With String
   * → 6 PIN codes
   */

  if (isWithString()) {

    return WITH_STRING_PINCODES;

  }


  /*
   * Product Only
   * → 112 PIN codes
   *
   * Normal Product
   * → 112 PIN codes
   */

  return BANGALORE_PINCODES;

}


/* =========================================================
   NORMALIZE PIN
   ========================================================= */

function normalizePincode(
  value
) {

  return String(
    value || ''
  )
    .replace(/\D/g, '')
    .slice(0, 6);

}


/* =========================================================
   VALIDATE PIN
   ========================================================= */

function validatePincode() {

  const input =
    getPincodeInput();


  const message =
    getPincodeMessage();


  if (
    !input ||
    !message
  ) {

    return false;

  }


  const pincode =
    normalizePincode(
      input.value
    );


  /*
   * Update input with
   * cleaned value
   */

  input.value =
    pincode;


  /* =====================================================
     EMPTY
     ===================================================== */

  if (!pincode) {

    message.textContent =
      'Please enter a PIN code.';

    return false;

  }


  /* =====================================================
     INVALID LENGTH
     ===================================================== */

  if (
    pincode.length !== 6
  ) {

    message.textContent =
      'Please enter a valid PIN code.';

    return false;

  }


  /* =====================================================
     CHECK ALLOWED LIST
     ===================================================== */

  const allowedPincodes =
    getAllowedPincodes();


  const available =
    allowedPincodes.includes(
      pincode
    );


  /* =====================================================
     AVAILABLE
     ===================================================== */

  if (available) {

    message.textContent =
      'Delivery available.';

    return true;

  }


  /* =====================================================
     NOT AVAILABLE
     ===================================================== */

  message.textContent =
    'Delivery is not available for this PIN code.';

  return false;

}


/* =========================================================
   INITIALIZE PIN VALIDATOR
   ========================================================= */

function initPincodeValidator() {

  const input =
    getPincodeInput();


  const button =
    document.querySelector(
      '#qs-pincode-check'
    );


  if (
    !input ||
    !button
  ) {

    return;

  }


  /*
   * Prevent duplicate listeners
   */

  if (
    button.dataset.pincodeReady === 'true'
  ) {

    return;

  }


  button.dataset.pincodeReady =
    'true';


  /* =====================================================
     CHECK BUTTON
     ===================================================== */

  button.addEventListener(
    'click',
    function () {

      validatePincode();

    }
  );


  /* =====================================================
     ENTER KEY
     ===================================================== */

  input.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Enter'
      ) {

        event.preventDefault();

        validatePincode();

      }

    }
  );


  /* =====================================================
     ONLY ALLOW NUMBERS
     ===================================================== */

  input.addEventListener(
    'input',
    function () {

      input.value =
        normalizePincode(
          input.value
        );

    }
  );

}  

/* =========================================================
   CHECK UNSTRUNG PRODUCT
   ---------------------------------------------------------
   Hide the complete delivery flow when:

   - Product title contains "Unstrung"
   - OR currently selected variant contains "Unstrung"

   String products remain completely unaffected.
   ========================================================= */

function isUnstrungProduct() {

  /*
   * Check product title
   */
  const titleSelectors = [
    'h1.productView__title',
    '.productView-title',
    'h1.product__title',
    '.product__title h1',
    '.product-title',
    '.product__title',
    'h1[itemprop="name"]',
    '[data-product-title]'
  ];

  for (const selector of titleSelectors) {

    const element =
      document.querySelector(selector);

    if (element) {

      const title =
        (
          element.innerText ||
          element.textContent ||
          ''
        )
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

      if (title.includes('unstrung')) {
        return true;
      }
    }
  }


  /*
   * Check currently selected Shopify variant
   */
  const variantSelectors = [
    'select[name^="options["]',
    'select[id*="Option-"]',
    'input[name="id"]',
    'input[name="variant"]'
  ];

  for (const selector of variantSelectors) {

    const elements =
      document.querySelectorAll(selector);

    for (const element of elements) {

      let text = '';

      if (
        element.tagName === 'SELECT'
      ) {

        const option =
          element.options[
            element.selectedIndex
          ];

        text =
          (
            option?.text ||
            element.value ||
            ''
          );

      } else {

        text =
          element.value || '';
      }

      text =
        text
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

      if (text.includes('unstrung')) {
        return true;
      }
    }
  }


  /*
   * Check selected/active variant labels
   */
  const activeElements =
    document.querySelectorAll(
      '.product-form__input input:checked + label, ' +
      '.product-form__input .selected, ' +
      '.product-form__input .active, ' +
      '[aria-selected="true"]'
    );

  for (const element of activeElements) {

    const text =
      (
        element.innerText ||
        element.textContent ||
        ''
      )
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

    if (text.includes('unstrung')) {
      return true;
    }
  }


  return false;
}


  /* =========================================================
     FIND PICKUP DATE
     ========================================================= */

  function getPickupDateInput() {

    for (
      const selector
      of PICKUP_DATE_SELECTORS
    ) {

      const input =
        document.querySelector(selector);


      if (
        input &&
        input.type === 'date'
      ) {

        return input;
      }
    }


    return null;
  }


  /* =========================================================
     FIND DELIVERY DATE
     ========================================================= */

  function getDeliveryDateInput() {

    for (
      const selector
      of DELIVERY_DATE_SELECTORS
    ) {

      const input =
        document.querySelector(selector);


      if (
        input &&
        input.type === 'date'
      ) {

        return input;
      }
    }


    return null;
  }


  /* =========================================================
     FIND DELIVERY SLOT
     ========================================================= */

  function getDeliverySlotInput() {

    for (
      const selector
      of DELIVERY_SLOT_SELECTORS
    ) {

      const input =
        document.querySelector(selector);


      if (input) {

        return input;
      }
    }


    return null;
  }


  /* =========================================================
     PICKUP DATE WRAPPER
     ========================================================= */

  function getPickupDateWrapper() {

    const dateInput =
      getPickupDateInput();


    if (!dateInput) {
      return null;
    }


    const deliveryField =
      dateInput.closest(
        '.qs-delivery-field'
      );


    if (deliveryField) {

      return deliveryField;
    }


    const customWrapper =
      dateInput.closest(
        '.custom-pickup-date-wrapper'
      );


    if (customWrapper) {

      return customWrapper;
    }


    return (
      dateInput.closest('.field') ||
      dateInput.closest('.product-form__input') ||
      dateInput.closest('.gpo-element') ||
      dateInput.parentElement
    );
  }


  /* =========================================================
     MOVE PICKUP SLOT BELOW PICKUP DATE
     ========================================================= */

  function moveSlotBelowPickupDate() {

    const slot =
      document.querySelector(SLOT);


    const dateWrapper =
      getPickupDateWrapper();


    if (
      !slot ||
      !dateWrapper
    ) {

      return;
    }


    if (
      dateWrapper.parentNode &&
      slot !==
        dateWrapper.nextElementSibling
    ) {

      dateWrapper.parentNode.insertBefore(
        slot,
        dateWrapper.nextSibling
      );
    }
  }


  /* =========================================================
     PICKUP SLOT VISIBILITY
     ========================================================= */

  function updatePickupSlotVisibility() {

    const slot =
      document.querySelector(SLOT);


    const pickupDate =
      getPickupDateInput();


    if (
      !slot ||
      !pickupDate
    ) {

      return;
    }


    if (pickupDate.value) {

      document.body.classList.add(
        'pickup-slot-visible'
      );


      slot.style.display =
        'block';

      slot.style.visibility =
        'visible';

      slot.style.opacity =
        '1';

    } else {

      document.body.classList.remove(
        'pickup-slot-visible'
      );


      slot.style.display =
        '';

      slot.style.visibility =
        '';

      slot.style.opacity =
        '';
    }
  }

/* =========================================================
   HIDE PASSED PICKUP TIME SLOTS
   ---------------------------------------------------------
   Only applies when Pickup Date = Today.

   Examples:
   12:30 PM
   → Hide 10 AM - 12 PM

   2:30 PM
   → Hide 10 AM - 12 PM
   → Hide 12 PM - 2 PM

   5:30 PM
   → Hide 10 AM - 12 PM
   → Hide 12 PM - 2 PM
   → Hide 2 PM - 5 PM

   8:30 PM
   → Hide all slots
   ========================================================= */

function updatePickupSlotTimeAvailability() {

  const pickupDateInput =
    getPickupDateInput();

  const pickupDropdown =
    document.querySelector(
      '[data-element-id="dropdown-1"]'
    );

  if (
    !pickupDateInput ||
    !pickupDropdown
  ) {
    return;
  }


  const selectedDate =
    pickupDateInput.value;

  if (!selectedDate) {
    return;
  }


  /* =====================================================
     GET TODAY
     ===================================================== */

  const now =
    new Date();

  const today =
    formatDate(now);


  /* =====================================================
     ONLY APPLY TIME RESTRICTION FOR TODAY
     ===================================================== */

  if (selectedDate !== today) {

    showAllPickupSlots(
      pickupDropdown
    );



    return;
  }


  /* =====================================================
     CURRENT TIME IN MINUTES
     ===================================================== */

  const currentMinutes =
    (
      now.getHours() * 60
    ) +
    now.getMinutes();


  /* =====================================================
     FIND GLOBO DROPDOWN ITEMS
     ===================================================== */

  const items =
    pickupDropdown.querySelectorAll(
      '.dropdown-list .dropdown-item'
    );


  if (!items.length) {
    return;
  }

  items.forEach(
    function (item) {

      const input =
        item.querySelector(
          'input[type="radio"]'
        );

      const label =
        item.querySelector(
          '.dropdown-item__value'
        );


      if (
        !input ||
        !label
      ) {
        return;
      }


      const text =
        (
          label.textContent ||
          input.value ||
          ''
        )
          .replace(/[–—]/g, '-')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();


      /* =================================================
         DETERMINE SLOT END TIME
         ================================================= */

      let slotStartMinutes =
        null;


      if (
        text.includes('10') &&
        text.includes('12')
      ) {

        /*
         * 10 AM - 12 PM
         * Hide from 10:00 AM
         */

        slotStartMinutes =
          10 * 60;
      }

      else if (
        text.includes('12') &&
        text.includes('2')
      ) {

        /*
         * 12 PM - 2 PM
         * Hide from 12:00 PM
         */

        slotStartMinutes =
          12 * 60;
      }

      else if (
        text.includes('2') &&
        text.includes('5')
      ) {

        /*
         * 2 PM - 5 PM
         * Hide from 2:00 PM
         */

        slotStartMinutes =
          14 * 60;
      }

      else if (
        text.includes('5') &&
        text.includes('8')
      ) {

        /*
         * 5 PM - 8 PM
         * Hide from 5:00 PM
         */

        slotStartMinutes =
          17 * 60;
      }


      /*
       * If this is not a recognized
       * time slot, leave it alone.
       */

      if (
        slotStartMinutes === null
      ) {
        return;
      }


      /* =================================================
         HIDE PASSED SLOT
         ================================================= */

      if (
        currentMinutes >=
        slotStartMinutes
      ) {

        item.style.display =
          'none';

        item.style.visibility =
          'hidden';

        item.style.pointerEvents =
          'none';


        input.disabled =
          true;

        input.checked =
          false;

      }

      else {

        /*
         * Future slot
         * → Show it.
         */

        item.style.display =
          '';

        item.style.visibility =
          '';

        item.style.pointerEvents =
          '';


        input.disabled =
          false;
      }

    }
  );

  /* =====================================================
     NO PICKUP SLOTS AVAILABLE
     ===================================================== */

  const visibleItems =
    Array.from(items).filter(function (item) {

      return (
        item.style.display !== 'none' &&
        item.style.visibility !== 'hidden'
      );

    });

  if (visibleItems.length === 0) {

    const dropdownButtonValue =
      pickupDropdown.querySelector(
        '.dropdown-button__value'
      );

    if (dropdownButtonValue) {

      dropdownButtonValue.textContent =
        'No slots available';

    }

  }  

}


/* =========================================================
   SHOW ALL PICKUP SLOTS
   ========================================================= */

function showAllPickupSlots(
  pickupDropdown
) {

  if (!pickupDropdown) {
    return;
  }


  const items =
    pickupDropdown.querySelectorAll(
      '.dropdown-list .dropdown-item'
    );


  items.forEach(
    function (item) {

      const input =
        item.querySelector(
          'input[type="radio"]'
        );


      item.style.display =
        '';

      item.style.visibility =
        '';

      item.style.pointerEvents =
        '';


      if (input) {

        input.disabled =
          false;
      }

    }
  );

  /* =====================================================
     RESET STALE "NO SLOTS AVAILABLE" MESSAGE
     WHEN PICKUP DATE HAS FUTURE AVAILABILITY
     ===================================================== */

  pickupDropdown
    .querySelectorAll('.dropdown-button__value')
    .forEach(function (element) {

      if (
        element.textContent
          .trim()
          .toLowerCase() ===
          'no slots available'
      ) {

        element.textContent =
          'Select a time slot';
      }

    });  

}  

  /* =========================================================
     DATE HELPERS
     ========================================================= */

  function formatDate(date) {

    const year =
      date.getFullYear();


    const month =
      String(
        date.getMonth() + 1
      ).padStart(2, '0');


    const day =
      String(
        date.getDate()
      ).padStart(2, '0');


    return (
      `${year}-${month}-${day}`
    );
  }


  function getTodayString() {

    return formatDate(
      new Date()
    );
  }


  function parseDate(value) {

    if (!value) {
      return null;
    }


    const parts =
      value.split('-');


    if (parts.length !== 3) {
      return null;
    }


    const date =
      new Date(
        Number(parts[0]),
        Number(parts[1]) - 1,
        Number(parts[2])
      );


    date.setHours(
      0,
      0,
      0,
      0
    );


    return date;
  }


  function addDays(
    date,
    days
  ) {

    const result =
      new Date(date);


    result.setDate(
      result.getDate() + days
    );


    result.setHours(
      0,
      0,
      0,
      0
    );


    return result;
  }

/* =========================================================
   CHECK MANUALLY DISABLED DATE
   ========================================================= */

function isDateDisabled(dateValue, type) {

  if (!dateValue) {
    return false;
  }

  if (type === 'delivery') {
    return DISABLED_DELIVERY_DATES.includes(
      dateValue
    );
  }

  return DISABLED_PICKUP_DATES.includes(
    dateValue
  );
}

function getNextAvailableDeliveryDate(
  startDate,
  maximumDate
) {

  let date =
    parseDate(startDate);

  const maximum =
    parseDate(maximumDate);

  while (
    date &&
    maximum &&
    date <= maximum &&
    isDateDisabled(
      formatDate(date),
      'delivery'
    )
  ) {

    date =
      addDays(
        date,
        1
      );
  }

  return date
    ? formatDate(date)
    : startDate;
}

  function daysBetween(
    pickupDate,
    deliveryDate
  ) {

    const start =
      parseDate(pickupDate);


    const end =
      parseDate(deliveryDate);


    if (
      !start ||
      !end
    ) {

      return null;
    }


    return Math.round(
      (
        end.getTime() -
        start.getTime()
      ) / 86400000
    );
  }


  /* =========================================================
     PICKUP SLOT TEXT
     ========================================================= */

  function getSelectedPickupSlotText() {

    const slot =
      document.querySelector(SLOT);


    if (!slot) {
      return '';
    }


    const select =
      slot.querySelector('select') ||
      (
        slot.matches('select')
          ? slot
          : null
      );


    if (select) {

      const option =
        select.options[
          select.selectedIndex
        ];


      return (
        option?.text ||
        select.value ||
        ''
      )
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }


    const radio =
      slot.querySelector(
        'input[type="radio"]:checked'
      );


    if (radio) {

      return (
        radio.closest('label')
          ?.innerText ||
        radio.value ||
        ''
      )
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }


    const active =
      slot.querySelector(
        '.selected, .active, [aria-selected="true"]'
      );


    if (active) {

      return active.innerText
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }


    return '';
  }

/* =========================================================
   PICKUP SLOT DISPLAY FORMAT
   Change "to" → "-" visually only
   ========================================================= */

function formatPickupSlotDisplay() {

  const pickupDropdown =
    document.querySelector(SLOT);

  if (!pickupDropdown) {
    return;
  }

  /* Change dropdown option text */
  pickupDropdown
    .querySelectorAll('.dropdown-item__value')
    .forEach(function (element) {

      element.textContent =
        element.textContent.replace(
          /\s+to\s+/gi,
          ' - '
        );

    });


  /* Change selected value inside dropdown button */
  pickupDropdown
    .querySelectorAll('.dropdown-button__value')
    .forEach(function (element) {

      element.textContent =
        element.textContent.replace(
          /\s+to\s+/gi,
          ' - '
        );

    });


  /* Change Globo selected-value display above dropdown */
  pickupDropdown
    .querySelectorAll('.gpo-selected-values')
    .forEach(function (element) {

      element.textContent =
        element.textContent.replace(
          /\s+to\s+/gi,
          ' - '
        );

    });

}

  /* =========================================================
     PICKUP SLOT KEY

     1 = 10-12
     2 = 12-2
     3 = 2-5
     4 = 5-8
     ========================================================= */

  function getPickupSlotKey() {

    const text =
      getSelectedPickupSlotText()
        .replace(/[–—]/g, '-');


    if (!text) {
      return null;
    }


    if (
      text.includes('10') &&
      text.includes('12') &&
      text.includes('am')
    ) {

      return 1;
    }


    if (
      text.includes('12') &&
      text.includes('2') &&
      text.includes('pm')
    ) {

      return 2;
    }


    if (
      text.includes('2') &&
      text.includes('5') &&
      text.includes('pm')
    ) {

      return 3;
    }


    if (
      text.includes('5') &&
      text.includes('8') &&
      text.includes('pm')
    ) {

      return 4;
    }


    return null;
  }


  /* =========================================================
     DELIVERY SLOT KEY
     ========================================================= */

  function getDeliverySlotKey(text) {

    const normalized =
      (
        text || ''
      )
        .replace(/[–—]/g, '-')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();


    if (
      normalized.includes('10') &&
      normalized.includes('12') &&
      normalized.includes('am')
    ) {

      return 1;
    }


    if (
      normalized.includes('12') &&
      normalized.includes('2') &&
      normalized.includes('pm')
    ) {

      return 2;
    }


    if (
      normalized.includes('2') &&
      normalized.includes('5') &&
      normalized.includes('pm')
    ) {

      return 3;
    }


    if (
      normalized.includes('5') &&
      normalized.includes('8') &&
      normalized.includes('pm')
    ) {

      return 4;
    }


    return null;
  }


  /* =========================================================
     SAME-DAY ALLOWED DELIVERY SLOTS
     ========================================================= */

  function getSameDayAllowedSlots() {

    const pickupSlot =
      getPickupSlotKey();


    /*
     * 10 AM - 12 PM
     * → 2 PM - 5 PM
     * → 5 PM - 8 PM
     */

    if (pickupSlot === 1) {

      return [4];
    }


    /*
     * 12 PM - 2 PM
     * → 5 PM - 8 PM
     */

    if (pickupSlot === 2) {

      return [4];
    }


    /*
     * 2 PM - 5 PM
     * 5 PM - 8 PM
     * → No same-day
     */

    if (
      pickupSlot === 3 ||
      pickupSlot === 4
    ) {

      return [];
    }


    return [];
  }


  /* =========================================================
     CALCULATE MINIMUM DELIVERY DATE
     ========================================================= */

  function getMinimumDeliveryDate() {

    const pickupInput =
      getPickupDateInput();


    if (
      !pickupInput ||
      !pickupInput.value
    ) {

      return getTodayString();
    }


    const pickupDate =
      parseDate(
        pickupInput.value
      );


    if (!pickupDate) {

      return getTodayString();
    }


    const pickupSlot =
      getPickupSlotKey();


    /*
     * If pickup is 2-5 or 5-8,
     * same-day delivery is unavailable.
     */

    if (
      pickupSlot === 2 ||
      pickupSlot === 3 ||
      pickupSlot === 4
    ) {

      return getNextAvailableDeliveryDate(
        formatDate(
        addDays(
          pickupDate,
          1
        )
      ),
      getMaximumDeliveryDate()
    );
  }


    /*
     * For 10-12
     * same-day delivery is possible.
     */

    return getNextAvailableDeliveryDate(
      formatDate(
      pickupDate
    ),
    getMaximumDeliveryDate()
    );
  }


  /* =========================================================
     CALCULATE MAXIMUM DELIVERY DATE
     ========================================================= */

  function getMaximumDeliveryDate() {

    const pickupInput =
      getPickupDateInput();


    if (
      !pickupInput ||
      !pickupInput.value
    ) {

      return null;
    }


    const pickupDate =
      parseDate(
        pickupInput.value
      );


    if (!pickupDate) {

      return null;
    }


    /*
     * Delivery date can only be selected
     * from the pickup date up to 4 days after pickup.
     */

    return formatDate(
      addDays(
        pickupDate,
        4
      )
    );
  }

/* =========================================================
   UPDATE PICKUP DATE MAXIMUM
   ---------------------------------------------------------
   Pickup Date can be selected only for the next 4 days.
   Example:
   Today       → 19 Aug
   +1 day      → 20 Aug
   +2 days     → 21 Aug
   +3 days     → 22 Aug
   +4 days     → 23 Aug
========================================================= */

function updatePickupDateMaximum() {

  const pickupInput =
    getPickupDateInput();

  if (!pickupInput) {
    return;
  }

  const today =
    new Date();

  const maximumDate =
    formatDate(
      addDays(
        today,
        4
      )
    );

  pickupInput.setAttribute(
    'max',
    maximumDate
  );

  /*
   * Clear Pickup Date if it is already
   * outside the allowed 4-day range.
   */
  if (
    pickupInput.value &&
    pickupInput.value > maximumDate
  ) {
    pickupInput.value = '';

    const deliveryInput =
      getDeliveryDateInput();

    if (deliveryInput) {
      deliveryInput.value = '';
      deliveryInput.removeAttribute('max');
    }

    const deliverySlot =
      getDeliverySlotInput();

    if (deliverySlot) {
      deliverySlot.value = '';
    }
  }
}

  /* =========================================================
     UPDATE DELIVERY DATE MINIMUM + MAXIMUM
     ========================================================= */

  function updateDeliveryDateMinimum() {

    const deliveryInput =
      getDeliveryDateInput();


    if (!deliveryInput) {

      return;
    }


    const minimumDate =
      getMinimumDeliveryDate();


    const maximumDate =
      getMaximumDeliveryDate();


    deliveryInput.setAttribute(
      'min',
      minimumDate
    );


    if (maximumDate) {

      deliveryInput.setAttribute(
        'max',
        maximumDate
      );

    } else {

      deliveryInput.removeAttribute(
        'max'
      );
    }


    /*
     * Clear an invalid delivery date.
     */

    if (
      deliveryInput.value &&
      (
        deliveryInput.value <
          minimumDate ||
        (
          maximumDate &&
          deliveryInput.value >
            maximumDate
        )
      )
    ) {

      deliveryInput.value = '';


      const deliverySlot =
        getDeliverySlotInput();


      if (deliverySlot) {

        deliverySlot.value = '';
      }


      document.body.classList.remove(
        'delivery-date-selected'
      );
    }
  }


  /* =========================================================
     SET BASIC DATE LIMITS
     ========================================================= */

  function setMinimumDate() {

    const today =
      getTodayString();


    const pickupInput =
      getPickupDateInput();


    if (pickupInput) {

      pickupInput.setAttribute(
        'min',
        today
      );


      if (
        pickupInput.value &&
        pickupInput.value < today
      ) {

        pickupInput.value = '';
      }

      /*
     * Clear manually disabled Pickup Date.
     */
    if (
      pickupInput.value &&
      isDateDisabled(
        pickupInput.value,
        'pickup'
      )
    ) {

      pickupInput.value = '';
    }
  }

    updatePickupDateMaximum();
    updateDeliveryDateMinimum();
  }

  

  /* =========================================================
     UPDATE DELIVERY SLOT AVAILABILITY
     ========================================================= */

  function updateDeliverySlotAvailability() {

    const deliveryInput =
      getDeliverySlotInput();


    const pickupInput =
      getPickupDateInput();


    const deliveryDateInput =
      getDeliveryDateInput();


    if (
      !deliveryInput ||
      !pickupInput ||
      !deliveryDateInput
    ) {

      return;
    }


    const pickupDate =
      pickupInput.value;


    const deliveryDate =
      deliveryDateInput.value;


    if (
      !pickupDate ||
      !deliveryDate
    ) {

      return;
    }


    const difference =
      daysBetween(
        pickupDate,
        deliveryDate
      );


    /*
     * Same day:
     *
     * Pickup 10-12 → Delivery 2-5 / 5-8
     * Pickup 12-2  → Delivery 5-8
     * Pickup 2-5   → No same day
     * Pickup 5-8   → No same day
     *
     * Next day / 2+ days:
     * All four slots available.
     */

    const isSameDay =
      difference === 0;


    let allowedSlots =
      isSameDay
        ? getSameDayAllowedSlots()
        : [1, 2, 3, 4];

/* =====================================================
NEXT-DAY DELIVERY SLOT RESTRICTION
===================================================== */

if (difference === 1) {

  const pickupSlot =
    getPickupSlotKey();


  /*
   * Pickup 3rd slot:
   * 2 PM - 5 PM
   *
   * Tomorrow:
   * Hide Delivery Slot 1
   * Keep Slots 2, 3, 4
   */

  if (pickupSlot === 3) {

    allowedSlots =
      [2, 3, 4];
  }


  /*
   * Pickup 4th slot:
   * 5 PM - 8 PM
   *
   * Tomorrow:
   * Hide Delivery Slots 1 and 2
   * Keep Slots 3, 4
   */

  if (pickupSlot === 4) {

    allowedSlots =
      [3, 4];
  }
}    

    let selectedOptionAllowed =
      false;


    const options =
      deliveryInput.querySelectorAll(
        'option'
      );


    options.forEach(
      function (option) {

        const key =
          getDeliverySlotKey(
            option.textContent
          );


        /*
         * Placeholder
         */

        if (!key) {

          option.hidden = false;
          option.disabled = false;
          option.style.display = '';

          return;
        }


        const allowed =
          allowedSlots.includes(key);


        /*
         * Hide invalid slot.
         */

        option.hidden =
          !allowed;


        /*
         * Disable invalid slot.
         */

        option.disabled =
          !allowed;


        /*
         * Extra protection for browsers/themes
         * that don't respect option.hidden.
         */

        option.style.display =
          allowed ? '' : 'none';


        if (
          allowed &&
          option.value ===
            deliveryInput.value
        ) {

          selectedOptionAllowed =
            true;
        }

      }
    );


    /*
     * If selected delivery slot is no longer valid,
     * clear it.
     */

    if (
      deliveryInput.value &&
      !selectedOptionAllowed
    ) {

      deliveryInput.value = '';


      deliveryInput.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );
    }

  }


  /* =========================================================
     DELIVERY FEE
     ========================================================= */

  function getDeliveryFee() {

    const pickupDate =
      getPickupDateInput()
        ?.value;


    const deliveryDate =
      getDeliveryDateInput()
        ?.value;


    if (
      !pickupDate ||
      !deliveryDate
    ) {

      return null;
    }


    const difference =
      daysBetween(
        pickupDate,
        deliveryDate
      );


    /*
     * Same day
     */

    if (
      difference === 0
    ) {

      return 100;
    }


    /*
     * Next day
     */

    if (
      difference === 1
    ) {

      return 50;
    }


    /*
     * 2+ days
     */

    if (
      difference >= 2
    ) {

      return 0;
    }


    return null;
  }


  /* =========================================================
     FIND SHOPIFY DELIVERY PRICING VARIANT CONTROL
     ========================================================= */

  function findDeliveryMethodControl() {

    /*
     * FIRST:
     * Look specifically for Shopify's variant option
     * named "Delivery Pricing".
     */

    const directSelectors = [
      'select[name*="Delivery Pricing"]',
      'select[name*="delivery-pricing"]',
      'select[name*="delivery_pricing"]'
    ];


    for (
      const selector
      of directSelectors
    ) {

      const select =
        document.querySelector(
          selector
        );


      if (select) {

        return select;
      }
    }


    /*
     * SECOND:
     * Find Shopify variant select by checking
     * its surrounding label/text.
     */

    const variantSelects =
      document.querySelectorAll(
        'select[name^="options["], select[id*="Option-"], select'
      );


    for (
      const select
      of variantSelects
    ) {

      const optionTexts =
        Array.from(
          select.options || []
        )
          .map(
            option =>
              (
                option.textContent || ''
              )
                .replace(/\s+/g, ' ')
                .trim()
                .toLowerCase()
          )
          .join(' | ');


      const wrapper =
        select.closest(
          '.product-form__input, .product-form__input--dropdown, .select, .gpo-element, [data-element-id]'
        ) ||
        select.parentElement;


      const wrapperText =
        (
          wrapper?.innerText || ''
        )
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();


      /*
       * Delivery Pricing option values must contain
       * all three prices.
       */

      const hasPricingOptions =
        optionTexts.includes('100') &&
        optionTexts.includes('50') &&
        optionTexts.includes('0');


      const isDeliveryPricing =
        wrapperText.includes(
          'delivery pricing'
        ) ||
        (
          select.name &&
          select.name
            .toLowerCase()
            .includes(
              'delivery pricing'
            )
        );


      if (
        hasPricingOptions &&
        isDeliveryPricing
      ) {

        return select;
      }
    }


    /*
     * FINAL FALLBACK:
     * Find any select containing all three
     * configured delivery prices.
     */

    for (
      const select
      of variantSelects
    ) {

      const text =
        Array.from(
          select.options || []
        )
          .map(
            option =>
              (
                option.textContent || ''
              ).toLowerCase()
          )
          .join(' | ');


      if (
        text.includes('100') &&
        text.includes('50') &&
        text.includes('0')
      ) {

        return select;
      }
    }


    return null;
  }


  /* =========================================================
     DELIVERY PRICING NORMAL TEXT
     ========================================================= */

  function updateDeliveryPricingVisibility() {

    const control =
      findDeliveryMethodControl();


    if (!control) {

      return;
    }


    /*
     * Find the complete Shopify option block.
     */

    let wrapper =
      control.closest(
        '.product-form__input, .product-form__input--dropdown, .product-form__option, .product-form__input-wrapper, .gpo-element, [data-element-id]'
      );


    /*
     * Fallback: walk upward until we find
     * an element containing "Delivery Pricing".
     */

    if (!wrapper) {

      let parent =
        control.parentElement;


      while (
        parent &&
        parent !== document.body
      ) {

        const text =
          (
            parent.innerText || ''
          )
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();


        if (
          text.includes(
            'delivery pricing'
          )
        ) {

          wrapper =
            parent;

          break;
        }


        parent =
          parent.parentElement;
      }
    }


    if (!wrapper) {

      return;
    }


    /*
     * Create normal text once.
     */

    let display =
      document.querySelector(
        '#qs-delivery-pricing-display'
      );


    if (!display) {

      display =
        document.createElement(
          'div'
        );


      display.id =
        'qs-delivery-pricing-display';


      display.style.marginTop =
        '10px';

      display.style.marginBottom =
        '10px';

      display.style.fontSize =
        '14px';

      display.style.fontWeight =
        '600';


      wrapper.parentNode.insertBefore(
        display,
        wrapper.nextSibling
      );
    }


    const fee =
      getDeliveryFee();


    let pricingText =
      '';


    if (fee === 100) {

      pricingText =
        'Delivery Pricing: Same-Day Delivery → ₹100';

    } else if (fee === 50) {

      pricingText =
        'Delivery Pricing: Next-Day Delivery → ₹50';

    } else if (fee === 0) {

      pricingText =
        'Delivery Pricing: 2 or more days after pickup → ₹0';
    }


    display.textContent =
      pricingText;


    /*
     * Product Only:
     * Hide dropdown and text.
     */

    if (isProductOnly()) {

      wrapper.style.setProperty(
        'display',
        'none',
        'important'
      );


      display.style.setProperty(
        'display',
        'none',
        'important'
      );


      return;
    }


    /*
     * With String:
     * Hide dropdown and show normal text.
     */

    wrapper.style.setProperty(
      'display',
      'none',
      'important'
    );


    display.style.setProperty(
      'display',
      pricingText
        ? 'block'
        : 'none',
      'important'
    );

  }


  /* =========================================================
     AUTOMATICALLY SELECT DELIVERY FEE
     ========================================================= */

  function updateAutomaticDeliveryFee() {

    /*
     * Product Only:
     * Hide pricing and do not select anything.
     */

    if (isProductOnly()) {

      updateDeliveryPricingVisibility();

      return;
    }


    const fee =
      getDeliveryFee();


    const control =
      findDeliveryMethodControl();


    if (!control) {

      console.warn(
        'Quickstrings: Delivery Pricing variant selector not found.'
      );


      updateDeliveryPricingVisibility();

      return;
    }


    /*
     * No valid delivery date yet.
     */

    if (fee === null) {

      updateDeliveryPricingVisibility();

      return;
    }


    let matchedOption =
      null;


    /*
     * Find the Shopify variant option
     * matching the calculated fee.
     */

    Array.from(
      control.options
    ).forEach(
      function (option) {

        const text =
          (
            option.textContent ||
            ''
          )
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();


        /*
         * Match the exact configured price.
         *
         * ₹200
         * ₹150
         * ₹100
         */




        if (
          (fee === 100 && text.includes('same-day delivery')) ||
          (fee === 50 && text.includes('next-day delivery')) ||
          (fee === 0 && text.includes('standard'))
        ) {

          matchedOption =
            option;
        }

      }
    );


    if (!matchedOption) {

      console.warn(
        'Quickstrings: No Delivery Pricing variant found for ₹' +
        fee
      );


      updateDeliveryPricingVisibility();

      return;
    }


    /*
     * Already selected.
     */

    if (
      control.value ===
      matchedOption.value
    ) {

      updateDeliveryPricingVisibility();

      return;
    }


    /*
     * Select correct Shopify variant option.
     */

    control.value =
      matchedOption.value;


    /*
     * IMPORTANT:
     * Trigger Shopify's normal variant
     * selection/change process.
     */

    control.dispatchEvent(
      new Event(
        'input',
        {
          bubbles: true
        }
      )
    );


    control.dispatchEvent(
      new Event(
        'change',
        {
          bubbles: true
        }
      )
    );


    /*
     * Some Shopify/theme variant systems
     * update asynchronously.
     */

    setTimeout(
      function () {

        const currentControl =
          findDeliveryMethodControl();


        if (
          currentControl &&
          currentControl.value !==
            matchedOption.value
        ) {

          currentControl.value =
            matchedOption.value;


          currentControl.dispatchEvent(
            new Event(
              'change',
              {
                bubbles: true
              }
            )
          );
        }

      },
      100
    );


    updateDeliveryPricingVisibility();

  }


  /* =========================================================
     UPDATE EVERYTHING
     ========================================================= */

  function updateDeliveryFlow() {

    const slot =
      document.querySelector(SLOT);


    if (!slot) {

      return;
    }


    const productOnly =
      isProductOnly();

    const unstrungProduct =
    isUnstrungProduct();

    const pickupDateSelected =
      isPickupDateSelected();


    const deliveryDateSelected =
      isDeliveryDateSelected();


    console.log(
      'Quickstrings Delivery Flow:',
      {
        productOnly,
        pickupDateSelected,
        deliveryDateSelected,
        pickupDate:
          getPickupDateInput()
            ?.value || '',
        pickupSlot:
          getSelectedPickupSlotText(),
        deliveryDate:
          getDeliveryDateInput()
            ?.value || '',
        deliveryFee:
          getDeliveryFee()
      }
    );


    /* =====================================================
       RESET STATES
       ===================================================== */

    document.body.classList.remove(
      'delivery-product-only',
      'delivery-unstrung-product',
      'delivery-with-string',
      'pickup-date-selected',
      'delivery-date-selected',
      'pickup-slot-visible'
    );

/* =====================================================
   UNSTRUNG PRODUCT
   ===================================================== */

if (unstrungProduct) {

  document.body.classList.add(
    'delivery-unstrung-product'
  );

  updateDeliveryPricingVisibility();

  document.body.classList.add(
    'delivery-flow-ready'
  );

  return;
}


    /* =====================================================
       PRODUCT ONLY
       ===================================================== */

    if (productOnly) {

      document.body.classList.add(
        'delivery-product-only'
      );


      /*
       * Explicitly hide delivery
       * pricing as well.
       */

      updateDeliveryPricingVisibility();
    }


    /* =====================================================
       WITH STRING
       ===================================================== */

    else {

      document.body.classList.add(
        'delivery-with-string'
      );


      if (pickupDateSelected) {

        document.body.classList.add(
          'pickup-date-selected'
        );
      }


      if (deliveryDateSelected) {

        document.body.classList.add(
          'delivery-date-selected'
        );
      }
    }


    /* =====================================================
       DATE LOGIC
       ===================================================== */

    setMinimumDate();


    /* =====================================================
       PICKUP SLOT
       ===================================================== */

    moveSlotBelowPickupDate();

    updatePickupSlotVisibility();

    updatePickupSlotTimeAvailability();

    formatPickupSlotDisplay();


    /* =====================================================
       DELIVERY SLOT LOGIC
       ===================================================== */

    updateDeliverySlotAvailability();


    /* =====================================================
       DELIVERY PRICE
       ===================================================== */

    updateAutomaticDeliveryFee();


    /* =====================================================
       READY
       ===================================================== */

    document.body.classList.add(
      'delivery-flow-ready'
    );

  }


  /* =========================================================
     CHECK PICKUP DATE
     ========================================================= */

  function isPickupDateSelected() {

    const input =
      getPickupDateInput();


    return !!(
      input &&
      input.value
    );
  }


  /* =========================================================
     CHECK DELIVERY DATE
     ========================================================= */

  function isDeliveryDateSelected() {

    const input =
      getDeliveryDateInput();


    return !!(
      input &&
      input.value
    );
  }


  /* =========================================================
     HANDLE CHANGES
     ========================================================= */

  document.addEventListener(
    'change',
    function (event) {


      /* =====================================================
         PICKUP DATE
         ===================================================== */

      const pickupDateInput =
        getPickupDateInput();


      if (
        pickupDateInput &&
        event.target ===
          pickupDateInput
      ) {

        console.log(
          'PICKUP DATE:',
          pickupDateInput.value
        );


        /*
         * Clear delivery date if
         * it is no longer valid.
         */

        const deliveryDateInput =
          getDeliveryDateInput();


        if (
          deliveryDateInput &&
          deliveryDateInput.value
        ) {

          const minimumDate =
            getMinimumDeliveryDate();


          const maximumDate =
            getMaximumDeliveryDate();


          if (
            deliveryDateInput.value <
              minimumDate ||
            (
              maximumDate &&
              deliveryDateInput.value >
                maximumDate
            )
          ) {

            deliveryDateInput.value =
              '';


            const deliverySlot =
              getDeliverySlotInput();


            if (deliverySlot) {

              deliverySlot.value =
                '';
            }

          }
        }


        updateDeliveryFlow();


        setTimeout(
          updateDeliveryFlow,
          100
        );


        setTimeout(
          updateDeliveryFlow,
          400
        );


        return;
      }


      /* =====================================================
         DELIVERY DATE
         ===================================================== */

      const deliveryDateInput =
        getDeliveryDateInput();


      if (
        deliveryDateInput &&
        event.target ===
          deliveryDateInput
      ) {

        console.log(
          'DELIVERY DATE:',
          deliveryDateInput.value
        );


        /*
         * Safety check:
         * do not allow a date outside the
         * pickup + 4 day range.
         */

        const minimumDate =
          getMinimumDeliveryDate();


        const maximumDate =
          getMaximumDeliveryDate();


        if (
          deliveryDateInput.value &&
          (
            deliveryDateInput.value <
              minimumDate ||
            (
              maximumDate &&
              deliveryDateInput.value >
                maximumDate
            ) ||

            isDateDisabled(
              deliveryDateInput.value,
              'delivery'
            )
          )
        ) {

          deliveryDateInput.value =
            '';


          const deliverySlot =
            getDeliverySlotInput();


          if (deliverySlot) {

            deliverySlot.value =
              '';
          }
        }


        updateDeliveryFlow();


        setTimeout(
          updateDeliveryFlow,
          100
        );


        return;
      }


      /* =====================================================
         PICKUP SLOT
         ===================================================== */

      const pickupSlotElement =
        event.target.closest(SLOT);


      if (pickupSlotElement) {

        console.log(
          'PICKUP SLOT:',
          getSelectedPickupSlotText()
        );


        /*
         * Pickup slot changes the
         * minimum delivery date.
         */

        const deliveryDateInput =
          getDeliveryDateInput();


        const minimumDate =
          getMinimumDeliveryDate();


        const maximumDate =
          getMaximumDeliveryDate();


        if (
          deliveryDateInput
        ) {

          deliveryDateInput.setAttribute(
            'min',
            minimumDate
          );


          if (maximumDate) {

            deliveryDateInput.setAttribute(
              'max',
              maximumDate
            );
          }


          /*
           * Clear delivery date if
           * pickup slot now makes it invalid.
           */

          if (
            deliveryDateInput.value &&
            (
              deliveryDateInput.value <
                minimumDate ||
              (
                maximumDate &&
                deliveryDateInput.value >
                  maximumDate
              )
            )
          ) {

            deliveryDateInput.value =
              '';


            const deliverySlot =
              getDeliverySlotInput();


            if (deliverySlot) {

              deliverySlot.value =
                '';
            }
          }
        }


        updateDeliveryFlow();


        setTimeout(
          updateDeliveryFlow,
          100
        );


        return;
      }


      /* =====================================================
         STRING TYPE
         ===================================================== */

      const stringTypeGroup =
        getStringTypeGroup();


      if (
        stringTypeGroup &&
        stringTypeGroup.contains(
          event.target
        )
      ) {

        console.log(
          'STRING TYPE CHANGED'
        );


        setTimeout(
          updateDeliveryFlow,
          100
        );


        setTimeout(
          updateDeliveryFlow,
          400
        );

      }

    }
  );


  /* =========================================================
     GLOBO RE-RENDER
     ========================================================= */

  function scheduleUpdate() {

    clearTimeout(
      updateTimer
    );


    updateTimer =
      setTimeout(
        function () {

          updateDeliveryFlow();

          /*
         * Globo may render the dropdown
         * slightly after the main update.
         */
        setTimeout(
          updatePickupSlotTimeAvailability,
          100
        );

        setTimeout(
          updatePickupSlotTimeAvailability,
          300
        );

        },
        100
      );
  }

/* =========================================================
   ADD TO CART VALIDATION
   ---------------------------------------------------------
   Customer cannot add to cart when:
   1. PIN code is invalid
   2. Pickup slot is empty
   3. Delivery slot is empty
   ========================================================= */

function validateBeforeAddToCart() {

  /* =====================================================
     1. VALIDATE PIN CODE
     ===================================================== */

  const pincodeInput =
    getPincodeInput();

  /*
   * If the PIN checker exists on the page,
   * validate the entered PIN.
   */
  if (pincodeInput) {

    if (!validatePincode()) {

      alert(
        'Please enter a valid PIN code before adding this product to cart.'
      );

      pincodeInput.focus();

      return false;
    }
  }


  /* =====================================================
     2. CHECK PICKUP SLOT
     ===================================================== */

  const pickupSlot =
    getPickupSlotKey();

  /*
   * Only require pickup slot when
   * the pickup/delivery flow is active.
   */
  const pickupSlotElement =
    document.querySelector(SLOT);

  if (
    pickupSlotElement &&
    !document.body.classList.contains(
      'delivery-unstrung-product'
    )
  ) {

    if (!pickupSlot) {

      alert(
        'Please select a Pickup Time Slot before adding this product to cart.'
      );

      pickupSlotElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      return false;
    }
  }


  /* =====================================================
     3. CHECK DELIVERY SLOT
     ===================================================== */

  const deliverySlot =
    getDeliverySlotInput();

  if (
    deliverySlot &&
    !document.body.classList.contains(
      'delivery-unstrung-product'
    )
  ) {

    if (!deliverySlot.value) {

      alert(
        'Please select a Delivery Time Slot before adding this product to cart.'
      );

      deliverySlot.focus();

      deliverySlot.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      return false;
    }
  }


  /* =====================================================
     ALL VALID
     ===================================================== */

  return true;
}


/* =========================================================
   HANDLE ADD TO CART BUTTON
   ========================================================= */

document.addEventListener(
  'click',
  function (event) {

    const button =
      event.target.closest(
        'button[name="add"], button[type="submit"][name="add"], .product-form__submit'
      );

    if (!button) {
      return;
    }


    /*
     * Only validate buttons that belong
     * to a product/add-to-cart form.
     */
    const form =
      button.closest(
        'form[action*="/cart/add"]'
      );

    if (!form) {
      return;
    }


    if (
      !validateBeforeAddToCart()
    ) {

      event.preventDefault();
      event.stopImmediatePropagation();

      return false;
    }

  },
  true
);


/* =========================================================
   HANDLE PRODUCT FORM SUBMIT
   ---------------------------------------------------------
   This catches:
   - Enter key submission
   - Theme-specific Add to Cart handling
   - Programmatic form submission
   ========================================================= */

document.addEventListener(
  'submit',
  function (event) {

    const form =
      event.target.closest(
        'form[action*="/cart/add"]'
      );

    if (!form) {
      return;
    }


    if (
      !validateBeforeAddToCart()
    ) {

      event.preventDefault();
      event.stopImmediatePropagation();

      return false;
    }

  },
  true
);

  /* =========================================================
     INITIALIZE
     ========================================================= */

  function init() {

    initPincodeValidator();
    updateDeliveryFlow();


    const observer =
      new MutationObserver(
        function () {

          scheduleUpdate();

        }
      );


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

    /* =========================================================
     PICKUP SLOT AVAILABILITY TIMER
     
     Refresh ONLY the pickup slot availability.
     Does NOT run updateDeliveryFlow().
     Does NOT refresh the whole page.
     ========================================================= */

  setInterval(function () {

    if (
      typeof updatePickupSlotTimeAvailability === 'function'
    ) {

      updatePickupSlotTimeAvailability();

    }

  }, 30000); // 30 seconds

document.addEventListener('click', function () {

    setTimeout(function () {
      formatPickupSlotDisplay();
    }, 50);

  });

  }


  /* =========================================================
     START
     ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );

  } else {

    init();

  }

})();

